import { render, staticRenderFns } from "./CourseraBody.vue?vue&type=template&id=1a5b9fe2&"
import script from "./CourseraBody.vue?vue&type=script&lang=ts&"
export * from "./CourseraBody.vue?vue&type=script&lang=ts&"
import style0 from "./CourseraBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports